var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareMegamenuIconPodcast = function SvgYeswareMegamenuIconPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#ECF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.323 14.74a.667.667 0 0 0-.67.67v1.515a6.16 6.16 0 0 1-6.153 6.152 6.16 6.16 0 0 1-6.152-6.152v-1.524a.667.667 0 0 0-.671-.67.667.667 0 0 0-.671.67v1.514c0 3.9 3 7.111 6.823 7.456v2.042c0 .373.297.67.671.67.374 0 .67-.297.67-.67V24.37c3.815-.335 6.824-3.555 6.824-7.456V15.4a.677.677 0 0 0-.67-.661Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.917a4.237 4.237 0 0 0-4.236 4.236v4.906a4.237 4.237 0 0 0 4.236 4.236 4.237 4.237 0 0 0 4.236-4.236v-4.907A4.237 4.237 0 0 0 17.5 7.917Zm1.255 6.66a.552.552 0 0 1-.536.412c-.048 0-.096-.01-.144-.019a2.096 2.096 0 0 0-1.14 0 .544.544 0 0 1-.68-.393.548.548 0 0 1 .392-.68 3.293 3.293 0 0 1 1.725 0c.288.076.46.383.383.68Zm.508-1.86a.556.556 0 0 1-.527.365.666.666 0 0 1-.191-.029 3.013 3.013 0 0 0-2.09 0 .565.565 0 0 1-.718-.335.551.551 0 0 1 .335-.71 4.178 4.178 0 0 1 2.856 0c.287.106.44.422.335.71Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareMegamenuIconPodcast;